import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取分销员列表
   */
  getdistributionList(
    MaxResultCount: number,
    currentPage: number,
    Name?: string,
    ReviewStatus?: number,
    StartTime?: string,
    EndTime?: string,
    AmountDistributionMin?: number,
    AmountDistributionMax?: number
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      Name,
      StartTime,
      EndTime
    }
    if (ReviewStatus != null) {
      params['ReviewStatus'] = ReviewStatus
    }
    if (AmountDistributionMin) {
      params['AmountDistributionMin'] = AmountDistributionMin
    }
    if (AmountDistributionMax) {
      params['AmountDistributionMax'] = AmountDistributionMax
    }
    return Ajax.get(`/api/distribution/distributionInfo/ListForView`, {
      params: params
    })
  },
  /**
   * 新的分销员列表，新增了许多字段
   */
  getdistributionList1(
    MaxResultCount: number,
    currentPage: number,
    Name?: string,
    ReviewStatus?: number,
    StartTime?: string,
    EndTime?: string,
    AmountDistributionMin?: number,
    AmountDistributionMax?: number
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      Name,
      StartTime,
      EndTime
    }
    if (ReviewStatus != null) {
      params['ReviewStatus'] = ReviewStatus
    }
    if (AmountDistributionMin) {
      params['AmountDistributionMin'] = AmountDistributionMin
    }
    if (AmountDistributionMax) {
      params['AmountDistributionMax'] = AmountDistributionMax
    }
    return Ajax.get(`/api/distribution/distributionInfo`, {
      params: params
    })
  },

  /**
   * 新增/更新分销员设置
   */
  updateDistributionSetting(obj: object) {
    return Ajax.put(`/api/distribution/distributionSetting`, obj)
  },

  /**
   * 获取分销员设置
   */
  getDistributionSetting() {
    return Ajax.get(`/api/distribution/distributionSetting`)
  },

  /**
   * 审核分销员
   * @param id
   * @param obj
   */
  verifyDistributionInfo(id: string, obj: object) {
    return Ajax.put(`/api/distribution/distributionInfo/${id}`, obj)
  },

  // 券包配置
  distributorCouponConfig(id: string, obj: object) {
    return Ajax.put(`/api/distribution/distributionInfo/coupon/${id}`, obj)
  },

  /**
   * 获取指定分销员信息
   * @param id
   */
  getDistributionInfo(id: string) {
    return Ajax.get(`/api/distribution/distributionInfo/${id}`)
  },

  /**
   * 批量删除分销员信息
   * @param ids
   */
  deleteDistributionInfo(ids: string[]) {
    return Ajax.delete(`/api/distribution/distributionInfo`, {
      params: {
        ids
      }
    })
  },

  /**
   * 禁用分销员信息
   * @param id
   */
  deleteDistribution(id: string) {
    return Ajax.put('/api/distribution/distributionInfo/UpdateIsActive', {
      id: id
    })
  },

  /**
   * 更新分销员信息
   * @param id
   */
  updateDistributionInfo(id: string, idCard: string, name: string) {
    let params = {
      id,
      idCard,
      name
    }
    return Ajax.put(`/api/distribution/distributionInfo/UpdateDistributionInfos`, params)
  },

  /**
   * 获取分销员分销订单记录
   * @param MaxResultCount
   * @param currentPage
   * @param DistributorInfoId
   */
  getDistributionOrder(
    MaxResultCount: number,
    currentPage: number,
    UserId: string
  ) {
    return Ajax.get(`/api/distribution/distributionOrder`, {
      params: {
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        UserId
      }
    })
  },

  /**
   * 获取分销员提现申请记录
   * @param MaxResultCount
   * @param currentPage
   * @param DistributorInfoId
   */
  getWithdrawRecord(
    MaxResultCount: number,
    currentPage: number,
    UserId?: string,
    KeyWord?: string
  ) {
    return Ajax.get(`/api/distribution/withdrawRecord`, {
      params: {
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        UserId,
        KeyWord
      }
    })
  },

  /**
   * 会员换绑申请列表
   */
  getReplacementAuditList(
    MaxResultCount: number,
    currentPage: number,
    KeyWord?: string,
    ReviewStatus?: number,
    StartTime?: string,
    EndTime?: string
  ) {
    return Ajax.get(`/api/distribution/distributionBinding`, {
      params: {
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        ReviewStatus,
        KeyWord,
        StartTime,
        EndTime
      }
    })
  },

  /**
   * 会员换绑审核操作
   */
  updateReviewStatus(
    id: number,
    reviewStatus?: number,
    remark?: string,
  ) {
    let obj = {
      id: id,
      reviewStatus: reviewStatus,
      remark: remark
    }
    return Ajax.put('/api/distribution/distributionBinding/updateReviewStatus', obj)
  },

  /**
   * 审核分销员提现申请
   * @param id
   * @param obj
   */
  verifyWithdrawRecord(id: string, obj: object) {
    return Ajax.put(`/api/distribution/withdrawRecord/${id}`, obj)
  },

  /**
   * 获取分销员团队
   * @param id
   */
  getDistributionTeam(
    MaxResultCount: number,
    currentPage: number,
    id: string
  ) {
    return Ajax.get(`/api/distribution/distributionInfo/MyDistributionTeam`, {
      params: {
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        id
      }
    })
  },
}
